import { asClusterId, asLeafKey, asPlantId, asRoleKey, isAdminGrant, isExceptionKey, isLanding } from '../types';
import type { ExceptionKey, MeAccess, PlantAccess, PlantId } from '../types';

import type { MePayload } from './schemas';

type PlantPayload = MePayload['plants'][string];

const plantAccessOf = (plant: PlantPayload): PlantAccess => ({
  deltas: new Map(Object.entries(plant.deltas)),
  licensed: new Set(plant.licensedModules),
  exceptions: new Set(plant.exceptions.filter((key): key is ExceptionKey => isExceptionKey(key))),
});

export const normalizeMe = (payload: MePayload): MeAccess => ({
  roleKey: payload.roleKey === null ? null : asRoleKey(payload.roleKey),
  adminGrant: payload.adminGrant !== null && isAdminGrant(payload.adminGrant) ? payload.adminGrant : null,
  clusterId: payload.adminGrantClusterId === null ? null : asClusterId(payload.adminGrantClusterId),
  isStaff: payload.isStaff,
  permissionsVersion: payload.permissionsVersion,
  landing: payload.landing !== null && isLanding(payload.landing) ? payload.landing : null,
  adminKeys: new Set(payload.adminKeys.map(asLeafKey)),
  baseKeys: new Set(payload.baseKeys),
  plantIds: payload.plantIds.map(asPlantId),
  plants: new Map(Object.entries(payload.plants).map(([plantId, plant]): [PlantId, PlantAccess] => [asPlantId(plantId), plantAccessOf(plant)])),
});

const normalizedPayloads = new WeakMap<MePayload, MeAccess>();

export const meAccessFrom = (payload: MePayload): MeAccess => {
  const known = normalizedPayloads.get(payload);
  if (known !== undefined) return known;
  const me = normalizeMe(payload);
  normalizedPayloads.set(payload, me);
  return me;
};
